
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curriculums",
      function () {
        return require("private-next-pages/curriculums/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curriculums"])
      });
    }
  